/**
 * TicketCellData.ts
 */
export class TicketCellData {
    constructor(value, row, column) {
        this.number = value;
        this.row = row;
        this.column = column;
        this.called = false;
        this.dabbed = false;
    }
    setCalled(value) {
        this.called = value;
    }
    setDabbed(value) {
        this.dabbed = value;
    }
    getNumber() {
        return this.number;
    }
    isCalled() {
        return this.called;
    }
    isDabbed() {
        return this.dabbed;
    }
    getRow() {
        return this.row;
    }
    getColumn() {
        return this.column;
    }
}
//# sourceMappingURL=TicketCellData.js.map